import { AccordionStateComponentProps } from "PFComponents/accordion";
import { Icon } from "PFComponents/icon";
import { IconName } from "PFTheme/graphics/icons";

export type IconSet = "chevron" | "caret";

const getIconName = (iconSet: IconSet, isOpen: boolean): IconName => {
  switch (iconSet) {
    case "chevron":
      return isOpen ? "chevron-down" : "chevron-right";
    case "caret":
      return isOpen ? "caret-down" : "caret-right";
  }
};

export const IconAccordionState = ({ isOpen, iconSet = "caret" }: AccordionStateComponentProps) => (
  <Icon name={getIconName(iconSet, isOpen)} size="sm" color="paletteBlue0" />
);
